module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "area-checkbox"
  }, _vm._l((_vm.areas), function(item, index) {
    return _c('div', {
      staticClass: "area"
    }, [_c('p', {
      class: [item.subareas.length ? 'underline' : ''],
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          return _vm.onClick(index, item)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n\n    ")]), _vm._v(" "), (_vm.type != 'radio') ? _c('input', {
      attrs: {
        "id": _vm.baseId + item.id,
        "type": _vm.type
      },
      on: {
        "change": function($event) {
          return _vm.onCheck([item])
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type == 'radio') ? _c('input', {
      attrs: {
        "id": _vm.baseId + item.id,
        "type": _vm.type,
        "name": "areaRadio"
      },
      on: {
        "change": function($event) {
          return _vm.onCheck([item])
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('b-collapse', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.areaActiveS[index]),
        expression: "!areaActiveS[index]"
      }],
      attrs: {
        "id": item.id.toString()
      },
      model: {
        value: (_vm.areaActiveS[index].active),
        callback: function($$v) {
          _vm.$set(_vm.areaActiveS[index], "active", $$v)
        },
        expression: "areaActiveS[index].active"
      }
    }, [_c('area-checkbox', {
      attrs: {
        "baseId": _vm.baseId,
        "type": _vm.type,
        "areas": item.subareas,
        "selected": _vm.selected
      },
      on: {
        "selectedAreaChanged": _vm.selectedAreaChanged
      }
    })], 1)], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87ec90bc","hasScoped":true}!./src/components/areaCheckbox/areaCheckbox.component.html
// module id = 548
// module chunks = 1